const BLUE = 'blue';
const ORANGE = 'orange';
const WHITE_BLUE = 'white';
const RED = 'red';
const NONE = 'none';
const OUTLINE_WHITE = 'outline-white';

export default {
  BLUE,
  ORANGE,
  WHITE_BLUE,
  NONE,
  RED,
  OUTLINE_WHITE,
};
